import { render, staticRenderFns } from "./ApplicationContacts.vue?vue&type=template&id=8fbdd04c&"
import script from "./ApplicationContacts.vue?vue&type=script&lang=js&"
export * from "./ApplicationContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports